import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const formataDate = (date, mask) => {
  if (!date) return '-';
  if (!mask) mask = 'MMM yyyy'
  const [ano, mes, dia] = date.split('-');
  return format(new Date(Number(ano), Number(mes - 1), Number(dia)), mask, { locale: ptBR })
};

const formataDatetime = (datetime, mask) => {
  if (!mask) mask = 'dd/MM/yyyy HH:mm:ss'
  return format(new Date(datetime), mask, { locale: ptBR })
};

export {
  formataDate,
  formataDatetime
}